import { BASE_PATH } from "../utils/constants";
import { buildProductApiUrl } from "../utils/geolocation";

export async function getProducts(page = 1, limit = 12, userCountry = 'global') {
  try {
    const baseUrl = `${process.env.REACT_APP_API_URL}/api/productos`;
    const additionalParams = {
      page: page,
      limit: limit,
      depth: 1,
      'where[_status][equals]': 'published'
    };

    const url = buildProductApiUrl(baseUrl, userCountry, additionalParams);
    const response = await fetch(url);

    if (!response.ok) {
      return {
        error: true,
        message: `Error in products ${response.status}: ${response.statusText}`,
      };
    }
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function getPopularProducts() {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/populares`;
    const response = await fetch(url);
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function getProduct(id) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/productos/${id}`;
    const response = await fetch(url);
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
    return null;
  }
}

/*
  // @route    GET /api/productos?[populate]=*&filters[marca][slug][$eq]=BRANDNAME
  // @desc     Get all products from a specific brand (paginated)
  // @access   Public
*/
export async function getBrandProducts(brandName, page = 1, limit = 12, userCountry = 'global') {
  console.log("getBrandProducts - brandName:", brandName, "page:", page, "country:", userCountry);
  try {
    const baseUrl = `${process.env.REACT_APP_API_URL}/api/productos`;
    const additionalParams = {
      'where[marca.slug][equals]': brandName,
      'where[_status][equals]': 'published',
      depth: 1,
      page: page,
      limit: limit
    };

    const url = buildProductApiUrl(baseUrl, userCountry, additionalParams);
    const response = await fetch(url);

    if (!response.ok) {
      return {
        error: true,
        message: `Error fetching brand products ${response.status}: ${response.statusText}`,
      };
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("getBrandProducts error:", error);
    return {
      error: true,
      message: "Error fetching brand products"
    };
  }
}

/*
  // @route    GET /api/productos?[populate]=*&filters[marca][slug][$eq]=BRANDNAME
  // @desc     Get ALL products from a specific brand (no pagination)
  // @access   Public
*/
export async function getAllBrandProducts(brandName, userCountry = 'global') {
  console.log("getAllBrandProducts - brandName", brandName);
  try {
    const baseUrl = `${process.env.REACT_APP_API_URL}/api/productos`;
    const additionalParams = {
      'where[marca.slug][equals]': brandName,
      'where[_status][equals]': 'published',
      depth: 1
      // No page or limit parameters - fetch all products
    };

    const url = buildProductApiUrl(baseUrl, userCountry, additionalParams);
    const response = await fetch(url);

    if (!response.ok) {
      return {
        error: true,
        message: `Error fetching all brand products ${response.status}: ${response.statusText}`,
      };
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("getAllBrandProducts error:", error);
    return {
      error: true,
      message: "Error fetching all brand products"
    };
  }
}

/*
  // @route    GET /api/productos?[populate]=*&filters[genero][slug][$eq]=GENRENAME
  // @desc     Get products from a specific genre (paginated)
  // @access   Public
*/
export async function getGenreProducts(genreName, page = 1, limit = 12, userCountry = 'global') {
  console.log("getGenreProducts - genreName:", genreName, "page:", page, "country:", userCountry);
  try {
    const baseUrl = `${process.env.REACT_APP_API_URL}/api/productos`;
    const additionalParams = {
      'where[genero.nombre][equals]': genreName,
      'where[_status][equals]': 'published',
      depth: 1,
      page: page,
      limit: limit
    };

    const url = buildProductApiUrl(baseUrl, userCountry, additionalParams);
    const response = await fetch(url);

    if (!response.ok) {
      return {
        error: true,
        message: `Error fetching genre products ${response.status}: ${response.statusText}`,
      };
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("getGenreProducts error:", error);
    return {
      error: true,
      message: "Error fetching genre products"
    };
  }
}

/*
  // @route    GET /api/productos?[populate]=*&filters[genero][slug][$eq]=GENRENAME
  // @desc     Get ALL products from a specific genre (no pagination)
  // @access   Public
*/
export async function getAllGenreProducts(genreName, userCountry = 'global') {
  console.log(userCountry);
  console.log("getAllGenreProducts - genreName:", genreName, "country:", userCountry);
  try {
    const baseUrl = `${process.env.REACT_APP_API_URL}/api/productos`;
    const additionalParams = {
      'where[genero.nombre][equals]': genreName,
      'where[_status][equals]': 'published',
      depth: 1
      // No page or limit parameters - fetch all products
    };

    const url = buildProductApiUrl(baseUrl, userCountry, additionalParams);
    const response = await fetch(url);

    if (!response.ok) {
      return {
        error: true,
        message: `Error fetching all genre products ${response.status}: ${response.statusText}`,
      };
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("getAllGenreProducts error:", error);
    return {
      error: true,
      message: "Error fetching all genre products"
    };
  }
}

/*
  // @route    GET /api/subastas/AUCTIONPRODUCID?[populate]=*
  // @desc     Get a specific auction product from an id
  // @access   Public
*/
export async function getAuctionProduct(id) {
  try {
    // const sortItem = "_sort=updatedAt:desc";
    const url = `${process.env.REACT_APP_API_URL}/api/subastas/${id}?depth=1`;
    const response = await fetch(url);
    if (!response.ok) {
      // Throw an error with the status code and message
      return {
        error: true,
        message: `Error en traer información de producto subasta ${response.status}: ${response.statusText}`,
      };
    }
    const result = await response.json();
    return result;
  } catch (error) {
    console.log("error");
    return null;
  }
}

/*
  // @route    GET /api/productos?[populate]=*&filters[condicion][slug][$eq]=CONDITIONNAME
  // @desc     Get products from a specific condition (paginated)
  // @access   Public
*/
export async function getConditionProducts(condition, page = 1, limit = 12, userCountry = 'global') {
  console.log("getConditionProducts - condition:", condition, "page:", page, "country:", userCountry);
  try {
    const baseUrl = `${process.env.REACT_APP_API_URL}/api/productos`;
    const additionalParams = {
      'where[condicion.nombre][equals]': condition,
      'where[_status][equals]': 'published',
      depth: 1,
      page: page,
      limit: limit
    };

    const url = buildProductApiUrl(baseUrl, userCountry, additionalParams);
    const response = await fetch(url);

    if (!response.ok) {
      return {
        error: true,
        message: `Error fetching condition products ${response.status}: ${response.statusText}`,
      };
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("getConditionProducts error:", error);
    return {
      error: true,
      message: "Error fetching condition products"
    };
  }
}

/*
  // @route    GET /api/productos?[populate]=*&filters[condicion][slug][$eq]=CONDITIONNAME
  // @desc     Get ALL products from a specific condition (no pagination)
  // @access   Public
*/
export async function getAllConditionProducts(condition, userCountry = 'global') {
  console.log("getAllConditionProducts - condition:", condition, "country:", userCountry);
  try {
    const baseUrl = `${process.env.REACT_APP_API_URL}/api/productos`;
    const additionalParams = {
      'where[condicion.nombre][equals]': condition,
      'where[_status][equals]': 'published',
      depth: 1
      // No page or limit parameters - fetch all products
    };

    const url = buildProductApiUrl(baseUrl, userCountry, additionalParams);
    const response = await fetch(url);

    if (!response.ok) {
      return {
        error: true,
        message: `Error fetching all condition products ${response.status}: ${response.statusText}`,
      };
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("getAllConditionProducts error:", error);
    return {
      error: true,
      message: "Error fetching all condition products"
    };
  }
}

/*
  // @route    GET /api/portada-catalogo
  // @desc     Get hero background for Catalogue page
  // @access   Public
*/
export async function getHeroCatalogue() {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/portadas/1`;
    const response = await fetch(url);
    const result = await response.json();
    return result;
  } catch (error) {
    console.log("error");
    return null;
  }
}
